import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Modal from 'flarum/common/components/Modal';

export default class SkyspireNotArrivedModal extends Modal {
  className() {
    return 'RenameDiscussionModal Modal--small';
  }

  title() {
    return app.translator.trans('dl-skyspire.forum.search_not_arrived_title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group">
            <p className="SkyspireNotArrivedModal-message">
              {app.translator.trans('dl-skyspire.forum.search_not_arrived')}
            </p>
          </div>
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" onclick={() => app.modal.close()}>
              {app.translator.trans('dl-skyspire.forum.close')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
